import { UserType } from 'types/user.types';

import { FEATURED_USERS_ADD, FETCH_LIKED_USERS } from '../action-types/shops-page.action-types';

export type ShopsPageReducer = {
  featuredUsers: UserType[];
  likedUsers: UserType[];
};

const initialState: ShopsPageReducer = {
  featuredUsers: [],
  likedUsers: [],
};

const shopsPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURED_USERS_ADD: {
      return {
        ...state,
        featuredUsers: action.data,
      };
    }
    case FETCH_LIKED_USERS: {
      return {
        ...state,
        likedUsers: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default shopsPageReducer;
